import Component from './FourOhFour'

export default Component
